/**
 * Main layout component with sidebar and header
 */
import React from 'react';
import { useAppContext } from '../../context/AppContext';
import Sidebar from './Sidebar';
import Header from './Header';
import NotificationContainer from './NotificationContainer';
import SecurityNoticeBanner from './SecurityNoticeBanner';
import ErrorBoundary from '../common/ErrorBoundary';

const Layout = ({ children }) => {
  const { state } = useAppContext();
  const { ui } = state;

  return (
    <div className={`min-h-screen bg-gray-50 ${ui.theme === 'dark' ? 'dark' : ''}`}>
      <div className="flex h-screen">
        {/* Sidebar */}
        <ErrorBoundary fallback={(error, retry) => (
          <div className="w-64 bg-red-50 p-4">
            <p className="text-red-600 text-sm">Sidebar error</p>
            <button onClick={retry} className="text-blue-600 text-sm">Retry</button>
          </div>
        )}>
          <Sidebar />
        </ErrorBoundary>

        {/* Main content area */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {/* Header */}
          <ErrorBoundary fallback={(error, retry) => (
            <div className="h-16 bg-red-50 p-4">
              <p className="text-red-600 text-sm">Header error</p>
              <button onClick={retry} className="text-blue-600 text-sm">Retry</button>
            </div>
          )}>
            <Header />
          </ErrorBoundary>

          {/* Sits above the content, below the header: visible on every screen until dismissed,
              without displacing the header's own controls. */}
          <ErrorBoundary fallback={() => null}>
            <SecurityNoticeBanner />
          </ErrorBoundary>

          {/* Main content */}
          <main className="flex-1 overflow-auto">
            <ErrorBoundary>
              {children}
            </ErrorBoundary>
          </main>
        </div>
      </div>

      {/* Notifications */}
      <NotificationContainer />
    </div>
  );
};

export default Layout;